import type { PaginaDeHistoricoDeContatos, PaginaDeOportunidades, ResumoDoDashboard } from "@base/contracts";
import { paraDataIso, periodoAnterior, type Intervalo } from "../../../shared/periodo/periodos";

/** Projeto sem fonte conectada: zeros e ausencia, nao numeros ilustrativos. */
export function resumoZerado(periodo: Intervalo): ResumoDoDashboard {
  const anterior = periodoAnterior(periodo);
  const metricas = {
    faturamentoCentavos: 0,
    faturamentoConsultaCentavos: 0,
    faturamentoTratamentoCentavos: 0,
    investimentoCentavos: null,
    vendas: 0,
    valorEmAbertoCentavos: 0,
  } as const;
  return {
    periodo: { inicio: paraDataIso(periodo.inicio), fim: paraDataIso(periodo.fim) },
    periodoAnterior: { inicio: paraDataIso(anterior.inicio), fim: paraDataIso(anterior.fim) },
    atual: metricas,
    anterior: { ...metricas, valorEmAbertoCentavos: null },
    funil: { gerenciador: null, crm: 0, mql: 0, agendado: 0, consulta: 0, venda: 0 },
    operacao: {
      cicloDeVendasDias: null,
      leadsAtivosNoPipeline: 0,
      tempoDeRespostaMinutos: null,
      precisaoDoRastreio: null,
      pacientesAntigos: 0,
    },
    atualizadoEm: null,
  };
}

export const PAGINA_VAZIA: PaginaDeOportunidades = { dados: [], proximoCursor: null, total: 0, rankingUtm: [] };
export const HISTORICO_VAZIO: PaginaDeHistoricoDeContatos = { dados: [], proximoCursor: null, total: 0 };
